
export enum MinuetExecutionStatusCd {
	COMPLETED = 'Completed',
	FAILED = 'Failed',
	NOT_STARTED = 'NotStarted',
	SKIPPED = 'Skipped',
	STARTED = 'Started'}

